export default {
  showSnackbar(context, payload) {
    if (payload === 'Expired token') {
      context.commit('setSnackbar', false)
      return
    }

    context.commit('setSnackbar', payload)
    setTimeout(() => {
      context.commit('setSnackbar', false)
    }, 10000)
  },
  showPopup(context, payload) {
    context.commit('setPopup', payload)
  },
  async getRatesCache(context, payload) {
    const oneHour = 3600000
    const now = Date.now()
    const noCache = payload?.noCache

    const ratesLastUpdated = context.getters.getRatesLastUpdated

    if (
      ratesLastUpdated &&
      now - ratesLastUpdated < oneHour &&
      Object.keys(context.getters.getRates).length > 0 &&
      noCache !== true
    ) {
      return context.getters.getRates
    }

    const ratesResults = await this.$api.$get(
      'currency/getrates' + (noCache ? '?noCache=1' : '')
    )
    const rates = ratesResults.results

    context.commit('setRates', rates)
    context.commit('setRatesLastUpdated', now)

    return rates
  }
}
